import { makeReparcelingSimulationsRepository } from 'modules/customer/infra/repositories';

import { FetchReparcelingSimulationsUseCase } from './implementations/FetchReparcelingSimulationsUseCase';

let instance: FetchReparcelingSimulationsUseCase | null = null;

export default function makeFetchReparcelingSimulationsUseCase() {
  if (!instance) {
    const repository = makeReparcelingSimulationsRepository();

    instance = new FetchReparcelingSimulationsUseCase(repository);
  }

  return instance;
}
